"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
/**
 * This includes "Downloads.html" and "ProductDownloads.html" partials
 */
var ProductDownloads = /** @class */ (function (_super) {
    __extends(ProductDownloads, _super);
    function ProductDownloads() {
        var _this = _super.call(this, constants_1.DATA_DOWNLOAD_WRAP) || this;
        if (!_this.getElement())
            return _this;
        _this.downloadsOpenBtn = _this.getElement().querySelector("[".concat(constants_1.DATA_DOWNLOAD_OPEN, "]"));
        _this.downloadsContent = _this.getElement().querySelector("[".concat(constants_1.DATA_DOWNLOAD_CONTENT, "]"));
        _this.initEventListeners();
        return _this;
    }
    /**
     * Init listeners
     * @private
     */
    ProductDownloads.prototype.initEventListeners = function () {
        var _this = this;
        this.downloadsOpenBtn.addEventListener('click', function () {
            _this.openDownloads();
        });
    };
    /**
     * Scroll to download element pos and open accordion
     * @private
     */
    ProductDownloads.prototype.openDownloads = function () {
        var _this = this;
        window.scrollTo({
            top: this.getElement().offsetTop - 90,
            behavior: 'smooth'
        });
        setTimeout(function () {
            _this.downloadsOpenBtn.classList.toggle(constantsClasses_1.CLASS_ACTIVE);
            _this.slideToggle(_this.downloadsContent);
        }, 300);
    };
    /**
     * Replacement for jquery 'slideToggle'
     * @private
     */
    ProductDownloads.prototype.slideToggle = function (element) {
        if (!element.classList.contains(constantsClasses_1.CLASS_ACTIVE)) {
            element.classList.add(constantsClasses_1.CLASS_ACTIVE);
            element.style.height = 'auto';
            var height_1 = element.clientHeight + 'px';
            element.style.height = '0px';
            setTimeout(function () {
                element.style.height = height_1;
            }, 0);
        }
        else {
            element.style.height = '0px';
            element.addEventListener('transitionend', function () {
                element.classList.remove(constantsClasses_1.CLASS_ACTIVE);
            }, { once: true });
        }
    };
    return ProductDownloads;
}(AbstractComponent_1.default));
exports.default = ProductDownloads;
